import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ContactForm from './components/ContactForm';
import ContactInfo from './components/ContactInfo';
import { useSEO } from '../../utils/seo';

const ContactPage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  useSEO({
    title: 'İletişim - Sigorta360 | Bize Ulaşın',
    description: 'Sigorta360 ile iletişime geçin. Dijital pazarlama hizmetlerimiz hakkında bilgi almak ve projelerinizi görüşmek için bize ulaşın. Ankara Çankaya merkezli hizmet.',
    keywords: 'sigorta360 iletişim, dijital ajans iletişim, sigorta pazarlama danışmanlık, sigorta360 telefon, sigorta360 adres, ankara dijital ajans',
    canonical: `${siteUrl}/iletisim`,
    schema: {
      '@context': 'https://schema.org',
      '@type': 'ContactPage',
      name: 'İletişim - Sigorta360',
      description: 'Sigorta360 iletişim bilgileri ve iletişim formu',
      url: `${siteUrl}/iletisim`,
      mainEntity: {
        '@type': 'Organization',
        name: 'Sigorta360',
        telephone: '+90-553-016-12-35',
        email: 'info@sigorota360.com',
        address: {
          '@type': 'PostalAddress',
          streetAddress: 'Kızılay Mah. Atatürk Bulv. No: 72/16',
          addressLocality: 'Çankaya',
          addressRegion: 'Ankara',
          addressCountry: 'TR'
        }
      }
    }
  });

  return (
    <div className="min-h-screen bg-platinum">
      <Header />
      <main>
        <section className="pt-32 pb-24">
          <div className="max-w-[1440px] mx-auto px-8">
            <div className="grid lg:grid-cols-2 gap-0 bg-white rounded-3xl shadow-2xl overflow-hidden">
              <ContactInfo />
              <ContactForm />
            </div>
          </div>
        </section>

        {/* Map */}
        <section className="pb-24">
          <div className="max-w-[1440px] mx-auto px-8">
            <div className="rounded-3xl overflow-hidden shadow-xl">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3060.2847654321!2d32.8540!3d39.9199!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14d34f190a9c6f35%3A0x5c8f8f8f8f8f8f8f!2zS8SxesSxbGF5LCBBdGF0w7xyayBCdWx2LiBObzo3Mi8xNiwgMDY0MjAgw4dhbmtheWEvQW5rYXJh!5e0!3m2!1str!2str!4v1234567890123!5m2!1str!2str"
                width="100%"
                height="400"
                style={{ border: 0, filter: 'grayscale(100%)' }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="hover:grayscale-0 transition-all duration-500"
              ></iframe>
            </div>
          </div>
        </section>
      </main>
      <Footer />

      {/* WhatsApp Button */}
      <a
        href="https://wa.me/905530161235"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-8 right-8 w-16 h-16 bg-green-500 rounded-full flex items-center justify-center shadow-2xl hover:scale-110 transition-all duration-300 z-50 animate-pulse cursor-pointer"
      >
        <i className="ri-whatsapp-line text-3xl text-white"></i>
      </a>
    </div>
  );
};

export default ContactPage;
